(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["account-banner"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const banners = document.querySelectorAll(".acc-banner");
  banners.forEach(banner => {
    const bar = banner.querySelector("#bar");
    const progressPercentage = banner.querySelector(".progress-percentage");

    const customerForm = document.querySelector('#profile-details form');
    const businessForm = document.querySelector('#business-details form');
    const addressList = document.querySelector('.address-list');

    function updateProgress() {
      // Get all input fields for customer and business forms
      // console.log("updateProgress")
      const customerFormInputs = Array.from(customerForm.querySelectorAll('.field__input'));
      const businessFormInputs = Array.from(businessForm.querySelectorAll('.field__input'));

      // Calculate percentage for customerForm
      let customerFilledCount = customerFormInputs.filter(input => input.value.trim() != '').length;
      const customerPercentage = (customerFilledCount / customerFormInputs.length) * 33.33;
    
      const businessFilledCount = businessFormInputs.filter(input => input.value !== '' || input.placeholder !== '').length;

      const businessPercentage = (businessFilledCount / businessFormInputs.length) * 33.33;
    
      const addressPercentage = addressList && addressList.children.length > 0 ? 33.33 : 0;

      // Total progress calculation
      const filledPercentage = customerPercentage + businessPercentage + addressPercentage;

      // Update the semi-circle progress
      const degree = 180 - (filledPercentage / 100) * 180;
      bar.style.transform = `rotate(-${degree}deg)`;

      // Update the percentage text
      progressPercentage.textContent = `${Math.round(filledPercentage)}%`;
    }
    // Add event listeners to update progress on input change
    const allInputs = [...customerForm.querySelectorAll('.field__input'), ...businessForm.querySelectorAll('.field__input')];
    allInputs.forEach(input => {
      input.addEventListener('input', updateProgress);
    });

    // Observe address-list for changes
    const observer = new MutationObserver(updateProgress);
    if (addressList) {
      observer.observe(addressList, { childList: true });
    }
    const updateNowButton = banner.querySelector('.update-now');
    updateNowButton.addEventListener('click', updateProgress);
    updateProgress();
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product-popup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
      function isIE() {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf('MSIE ');
        const trident = ua.indexOf('Trident/');

        return msie > 0 || trident > 0;
      }

      if (!isIE()) return;
      const hiddenInput = document.querySelector('#{{ product_form_id }} input[name="id"]');
      const noScriptInputWrapper = document.createElement('div');
      const variantPicker = document.querySelector('variant-selects[data-section="{{ section.id }}"]');
      noScriptInputWrapper.innerHTML = document.querySelector(
        '.product-form__noscript-wrapper-{{ section.id }}'
      ).textContent;
      variantPicker.outerHTML = noScriptInputWrapper.outerHTML;

      document.querySelector('#Variants-{{ section.id }}').addEventListener('change', function (event) {
        hiddenInput.value = event.currentTarget.value;
      });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["request-query"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
      const customSelect = document.getElementById('customSelect');
      const trigger = customSelect.querySelector('.request-query .request-select__trigger');
      const options = document.querySelectorAll('.request-query .custom-option');
      const hiddenSelect = document.getElementById('CustomerForm-business_sector');
      const selectedOption = document.querySelector('.request-select__trigger .selected-option');
    
      customSelect.addEventListener('click', function () {
        customSelect.classList.toggle('open'); 
      });
    
      options.forEach(option => {
        option.addEventListener('click', function () {
          event.stopPropagation();
         event.preventDefault();    
          customSelect.classList.remove('open');
          options.forEach(opt => opt.classList.remove('selected'));
          this.classList.add('selected');
          const value = this.getAttribute('data-value');
          const text = this.textContent.trim();
          
          selectedOption.textContent = text;
          hiddenSelect.value = value;   
        });
      });
    
      document.addEventListener('click', function (e) {
        if (!customSelect.contains(e.target)) {
          customSelect.classList.remove('open');
        }
      });
  })
  } catch(e) { console.error(e); }
})();

})();
